import React from "react";
import {
  ContentLayout,
  CustomTable,
  HeaderBreadcrumbs,
  DeleteModal,
  CustomeDialog,
  Loader,
} from "../../../shared";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useStampCardRewardList } from "../hooks";
import AddIcon from "@mui/icons-material/Add";

export const StampCardsRewardsList = ({ isPublished = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { state, handleModal, confirmDelete } = useStampCardRewardList();

  const ActionButtons = ({ rId, deleteAction }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <Typography
          variant="subtitle2"
          color={"#1560D4"}
          sx={{
            cursor: "pointer",
          }}
          className="LinkBtn"
          onClick={() => handleModal("products", true, rId)}
        >
          Products
        </Typography>

        {isPublished ? (
          <img
            alt="edit"
            src="/icons/ic_edit.svg"
            style={{ cursor: "default", opacity: 0.5, marginLeft: 8 }}
          />
        ) : (
          <Link to={`reward/${rId}/edit`}>
            <img alt="edit" src="/icons/ic_edit.svg" />
          </Link>
        )}

        <img
          alt="delete"
          onClick={() => {
            if (isPublished) return;
            handleModal("delete", true, rId);
          }}
          src="/icons/ic_delete.svg"
          style={{
            cursor: isPublished ? "default" : "pointer",
            opacity: isPublished ? 0.5 : 1,
            marginLeft: 8,
          }}
        />
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Milestones",
        accessor: "milestone",
      },
      {
        Header: "Stamps to unlock",
        accessor: "stamps_unlock",
      },
      {
        Header: "Reward Title",
        accessor: "reward_title",
      },
      {
        Header: "Validity(days)",
        accessor: "validity",
        align: "center",
        Cell: ({ value }) => `${value} days`,
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: (row, index) => {
          return <ActionButtons rId={row?.id} deleteAction={() => {}} />;
        },
      },
    ],
    [navigate, isPublished],
  );

  return (
    <>
      <CustomTable
        columns={columns}
        data={state.dataList}
        isLoading={state.isLoading}
        // defaultSearch={true}
        tableId="stampRewards"
        tableTitle="Stamp Rewards"
        headerRightContent={
          <>
            {!isPublished && (
              <Button
                type="button"
                size="medium"
                variant="text"
                className="delte"
                startIcon={<AddIcon />}
                onClick={() => navigate(`reward/create`)}
              >
                Add Reward
              </Button>
            )}
          </>
        }
      />

      <DeleteModal
        open={state.isDeleteModalOpen && !isPublished}
        description="Are you sure you want to delete this reward?"
        handleClose={() => handleModal("delete", false, null)}
        onConfirm={() => confirmDelete()}
      />

      <CustomeDialog
        open={state.isModalOpen}
        handleClose={() => handleModal("products", false, null)}
        PaperProps={{
          sx: {
            width: "423px",
            height: "500px",
            p: "16px",
            gap: "12px",
            overflow: "hidden",
          },
        }}
        title={state.selectedReward?.reward_title || "Reward Products"}
        content={
          <Stack gap="12px" maxHeight="100%" overflow="auto">
            {state.isproductsLoading ? (
              <Loader />
            ) : (
              state.selectedReward?.reward_groups?.map((group) => (
                <Stack
                  key={group.group_id}
                  borderRadius="8px"
                  overflow="hidden"
                  border="1px solid #E0E0E0"
                >
                  <Stack
                    px="12px"
                    py="8px 16px"
                    justifyContent="center"
                    height="33px"
                    bgcolor="#F3F3F3"
                  >
                    <Typography fontSize="14px" fontWeight={600}>
                      {group.group_title}
                    </Typography>
                  </Stack>

                  <Stack
                    sx={{
                      height: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {group.products.map((product) => (
                      <Stack
                        key={product.id}
                        px="16px"
                        py="7px"
                        borderTop="1px solid #E0E0E0"
                      >
                        <Typography fontSize="14px" fontWeight={400}>
                          {product.name}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Stack>
              ))
            )}
          </Stack>
        }
      />
    </>
  );
};
